import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import DoughnutPercentageChart from '../../DoughnutPercentageChart';
import BudgetDoughnutTooltip from '../BudgetDoughnutTooltip';

function BudgetDoughnut(props) {
  const { question } = props;
  const { labels, percentages, values } = question.data.averages;
  const chartRef = useRef(null);

  return (
    <div>
      <div ref={chartRef}>
        <DoughnutPercentageChart
          data={percentages}
          labels={labels}
          extraDatasets={[{ data: values, hidden: true }]}
          Tooltip={BudgetDoughnutTooltip}
        />
      </div>
    </div>
  );
}

BudgetDoughnut.propTypes = {
  question: PropTypes.shape({
    data: PropTypes.shape({
      averages: PropTypes.shape({
        labels: PropTypes.arrayOf(PropTypes.string).isRequired,
        values: PropTypes.arrayOf(PropTypes.number).isRequired,
        percentages: PropTypes.arrayOf(PropTypes.number).isRequired,
      }).isRequired,
      datasets: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          labels: PropTypes.arrayOf(PropTypes.string).isRequired,
          counts: PropTypes.arrayOf(PropTypes.number).isRequired,
          percentages: PropTypes.arrayOf(PropTypes.number).isRequired,
          statistics: PropTypes.shape({
            min: PropTypes.number.isRequired,
            max: PropTypes.number.isRequired,
            median: PropTypes.number.isRequired,
            mean: PropTypes.number.isRequired,
            stdDev: PropTypes.number,
            meanDiff: PropTypes.number,
            comparisonValueLabel: PropTypes.string.isRequired,
            comparisonValue: PropTypes.number,
            mode: PropTypes.number.isRequired,
          }).isRequired,
        }).isRequired
      ).isRequired,
    }).isRequired,
  }).isRequired,
};

export default BudgetDoughnut;
